<div class="row">
  <div class="col-12 text-right icon-mat-close">
    <i class="bi bi-x" (click)="closeDialog()"></i>
  </div>
  <div class="custom-card extend-card">
    <div class="col-12">
      <table mat-table class="tabletop" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <ng-container>
              <!--
                <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
              -->
            </ng-container>
          </th>
        </ng-container>
        <ng-container matColumnDef="type_code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
          <td mat-cell *matCellDef="let element">{{ element?.type_code }}</td>
        </ng-container>
        <ng-container matColumnDef="type_value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.type_code == 'FTR/ITN'">
              <input
                class="input-value form-control"
                [(ngModel)]="element.type_value"
                [value]="element?.type_value" />
              <!--
            appFTRITRNFilter
                (onValidate)="onValidate($event, element)" 
            --></div>

            <div *ngIf="element.type_code == 'MRN'">
              <input
                class="input-value form-control"
                [(ngModel)]="element.type_value"
                [value]="element?.type_value"
                appMRNFilter
                (onValidate)="onValidate($event, element)" />
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div *ngIf="row.index > 0">
              <i
                class="m-1 icon-mat"
                *ngIf="dataSource.data.length - 1 == row.index"
                [matTooltip]="'Add'"
                mat-raised-button
                (click)="Add()">
                <em class="bi bi-plus"></em>
              </i>
              <i
                *ngIf="row.index > 1"
                [matTooltip]="'Delete'"
                (click)="remove(row)"
                class="m-1 icon-mat bi bi-trash"></i>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
